import { useState, useCallback, useContext, useEffect, useMemo, useRef } from "react";
import { Dropdown, Popover, SideSheet, Tree, Input, Button, Toast } from "@douyinfe/semi-ui";
import { IconChevronLeft, IconMailStroked1 } from '@douyinfe/semi-icons';
import Link from 'next/link'
import { IndexContext } from "@/stores";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import styles from "./styles.module.scss";
import cName from "classnames";
import useRequest from '@/utils/useRequest';

export default ({ }) => {
  const router = useRouter()
  const t = useTranslations();
  const request = useRequest()

  const { menuList, menuCurrent, menuParent, webInfo } = useContext(IndexContext);

  const difference = useMemo(() => {
    const exhibition_start_time = Number(webInfo?.find((item: any) => item.code === 'exhibition_start_time')?.content);
    const _difference = String(Math.ceil((exhibition_start_time - Date.now()) / (1000 * 60 * 60 * 24)));
    return _difference
  }, [webInfo]);

  const [isShowMenu, setIsShowMenu] = useState<boolean>(false)

  const changeLang = useCallback((locale: 'cn' | 'en') => {
    router.push(router.asPath, router.asPath, { locale })
  }, [router])
  const getTreeData = useCallback((data: any) => {
    return data?.map((item: any) => {
      return {
        label: item?.title,
        key: String(item?.id),
        children: getTreeData(item?.childlist || []),
        ...item
      }
    })
  }, [])
  const renderFullLabel = useCallback(({ className, data, expandIcon, onClick, onExpand }: any) => {
    const isLeaf = !(data.children && data.children.length);
    return (
      <li className={className} role="treeitem" onClick={isLeaf ? onClick : onExpand}>
        {isLeaf ? null : expandIcon}
        <span>{data?.label}</span>
      </li>
    )
  }, [])
  const gotoPage = useCallback((item: any) => {
    setIsShowMenu(false)
    if (item?._target == "_blank") {
      window.open(item?._href, '_blank');
    } else {
      router.push(item?._href, item?._href, {});
    }
  }, [])

  const [formModel, setFormModel] = useState({
    truename: "",
    mobile: "",
    email: "",
    company: "",
  })

  const [isShowMessage, setIsShowMessage] = useState<boolean>(true)

  const submitMessage = useCallback(async () => {
    if (!formModel?.truename || (router.locale === 'cn' && !formModel?.mobile) || (router.locale === 'en' && !formModel?.email) || !formModel?.company) {
      return Toast.error({
        content: t('common.message.fill'),
      })
    }
    const { data } = await request.post('/addMessageBoard', {
      ...formModel,
    })
    if (data?.code == 200) {
      Toast.success({
        content: t('common.message.success'),
      })
      setFormModel({
        truename: "",
        mobile: "",
        email: "",
        company: "",
      })
    } else {
      Toast.error({
        content: data.msg,
      })
    }
  }, [formModel])

  return (
    <header className={cName(styles.header, router.locale === 'en' && styles.en)}>
      <Link href="/">
        <a className={styles.logo}>
          <img src="https://img.ipbexpo.com/editor/20260107/5d22555ed4f42918d3e8cebc75b155aa695e1074dfcf5.png" alt="" />
        </a>
      </Link>
      <ul className={styles.menu}>
        {
          menuList?.map((item: any, index: number) => (
            <Popover
              key={index}
              content={
                <ul className={styles.childs}>
                  {
                    item?.childlist?.map((child: any) => (
                      <li key={child?.id}>
                        <Link href={child?._href || '/'}>
                          <a className={cName([styles.child, (child?._href == menuCurrent?._href || child?.id == menuCurrent?.id) && styles.active])} target={child?._target || '_self'}>{child.title}</a>
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              }
              getPopupContainer={() => document.getElementById(`item_${item?.id}`) as HTMLElement}
              showArrow={true}
              style={{ display: item?.childlist?.length ? 'block' : 'none' }}
              trigger="hover"
            >
              <li id={`item_${item?.id}`} className={cName([styles.item, (item?._href == menuCurrent?._href || item?.id == menuCurrent?.pid) && styles.active])}>
                <Link href={item?._href || '/'}>
                  <a className={styles.link} target={item?._target || '_self'}>{item.title}</a>
                </Link>
                <ul className={styles.childs} style={{ display: 'none' }}>
                  {
                    item?.childlist?.map((child: any) => (
                      <li key={child?.id}>
                        <Link href={child?._href || '/'}>
                          <a className={styles.child} target={child?._target || '_self'}>{child.title}</a>
                        </Link>
                      </li>
                    ))
                  }
                </ul>
              </li>
            </Popover>
          ))
        }
      </ul>
      <div className={styles.btns}>
        <div id="lang" className={styles.lang} onClick={() => changeLang(router.locale === 'en' ? 'cn' : 'en')}>{router.locale === 'en' ? '中文' : 'English'}</div>
        {/* <Dropdown
          getPopupContainer={() => document.getElementById('lang') as HTMLElement}
          render={
            <Dropdown.Menu className={styles.langs}>
              <Dropdown.Item onClick={() => changeLang('cn')}>中文</Dropdown.Item>
              <Dropdown.Item onClick={() => changeLang('en')}>English</Dropdown.Item>
            </Dropdown.Menu>
          }
          trigger="click"
        >
          <div id="lang" className={styles.lang}>{router.locale === 'en' ? '语言：中文' : 'English'}</div>
        </Dropdown> */}
        <div className={styles.countdown}>
          {t('common.cout')}
          <span>{difference}</span>
          {t('common.day')}
        </div>
      </div>
      <img className={styles.nav} src="/image/menu.png" alt="" onClick={() => setIsShowMenu(!isShowMenu)} />
      <SideSheet title="IPB 2027" placement="left" visible={isShowMenu} width="75%" onCancel={() => setIsShowMenu(!isShowMenu)}>
        <Tree
          treeData={getTreeData(menuList)}
          renderFullLabel={renderFullLabel}
          onSelect={(selectedKey: string, selected: boolean, selectedNode: any) => {
            gotoPage(selectedNode)
          }}
        />
      </SideSheet>
      {
        isShowMessage
          ?
          <div className={styles.message}>
            <img className={styles.elf} src="/image/engineer2.png" alt="" />
            <img className={styles.close} src="/image/icon-close.png" alt="" onClick={() => setIsShowMessage(false)} />
            <div className={styles.wrap}>
              <p className={styles.hint}>{t('common.message.hint')}</p>
              <Input className={styles.input} value={formModel.truename} onChange={(value) => setFormModel({ ...formModel, truename: value })} placeholder={t('common.message.truename')} prefix={<img className={styles.icon} src="/image/icon-user.png" alt="" />}></Input>
              {
                router.locale == 'cn'
                  ?
                  <Input className={styles.input} value={formModel.mobile} onChange={(value) => setFormModel({ ...formModel, mobile: value })} placeholder={t('common.message.mobile')} prefix={<img className={styles.icon} src="/image/icon-phone.png" alt="" />}></Input>
                  :
                  <Input className={styles.input} value={formModel.email} onChange={(value) => setFormModel({ ...formModel, email: value })} placeholder={t('common.message.email')} prefix={<IconMailStroked1 className={styles.icon} />}></Input>
              }
              <Input className={styles.input} value={formModel.company} onChange={(value) => setFormModel({ ...formModel, company: value })} placeholder={t('common.message.company')} prefix={<img className={styles.icon} src="/image/icon-office.png" alt="" />}></Input>
              <Button className={styles.btn} onClick={submitMessage}>{t('common.message.submit')}</Button>
            </div>
          </div>
          :
          <div className={styles.spread} onClick={() => setIsShowMessage(true)}>
            <IconChevronLeft />
          </div>
      }
      <style jsx global lang='scss'>
        {
          `
            .semi-portal{
              z-index: 10000 !important;
            }
            .semi-sidesheet-title{
              width: 80%;
            }
            .semi-tree-option{
              padding: 8px 12px !important;
            }
          `
        }
      </style>
    </header>
  );
};
